<style lang="less" scoped>
@import url('./index.less');
</style>

<template>
  <div class="disease-scroll">
    <div class="experts-question-wrap">
      <div class="dropdown-wrap">
        <van-dropdown-menu active-color="#FE7922" :style="{height:'40px'}">
          <van-dropdown-item @change="changeDiseaseHandle" v-model="value1" :options="parent.parentTabSelect.popularScienceFields" />
          <van-dropdown-item @change="changeTagHandle" v-model="value2" :options="parent.parentTabSelect.popularScienceTags" />
        </van-dropdown-menu>
      </div>
      <div class="article-num">共{{sum}}篇科普</div>
      <div class="experts-question-list-container">
        <div v-for="(item,index) in list" :key="index" @click="clickhandle(item)">
          <ICell :dataItem="item" />
        </div>
      </div>
    </div>
    <div class="empty" v-if="list.length === 0">
      <Empty />
    </div>
  </div>
</template>

<script>
import { DropdownMenu, DropdownItem, Toast } from 'vant';
import { debounce, statisticalHandle } from 'utils/baseMethods.js'
import ICell from '@/components/ICell'
import { HttpRequest} from 'utils/'
export default {
  data() {
    return {
      value1: '',
      value2: '',
      // option1: [
      //   { text: '全部疾病', value: '' },
      //   { text: '肿瘤', value: '肿瘤' },
      //   { text: '呼吸', value: '呼吸' },
      //   { text: '心血管', value: '心血管' },
      //   { text: '内分泌', value: '内分泌' },
      //   { text: '其他', value: '其他' }
      // ],
      // option2: [
      //   { text: '全部标签', value: '' },
      //   { text: '科普知识', value: '科普知识' },
      //   { text: '就医指导', value: '就医指导' },
      //   { text: '购药指导', value: '购药指导' },
      //   { text: '心理疏导', value: '心理疏导' },
      // ],
      list: [],
      sum:0,
      page:1,
    }
  },
  components:{
    ICell,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  },
  inject:['parent'],
  created() {
    this.getListData()
    this.$nextTick(()=>{
      console.log(this.$el)
      this.$el.onscroll = debounce(()=>{
        const scrollHeight = this.$el.scrollHeight
        const scrollTop = this.$el.scrollTop
        const clientHeight = this.$el.clientHeight
        if(scrollHeight - (clientHeight + scrollTop) <= 50 ){
          if (this.sum !== this.list.length) {
            this.page += 1
            this.getListData()
          }
        }
      },100)
    })
  },
  methods:{
    async getListData() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      });
      const res = await HttpRequest({
        url:'/professional/popular_sciences/',
        params:{
          page:this.page,
          tag:this.value2,
          field_level1:this.value1
        }
      })
      Toast.clear()
      this.sum = res.count
      if(res.results.length) {
        this.list = [
          ... this.list,
          ... res.results
        ]
      }
    },
    changeDiseaseHandle(value) {
      console.log(value)
      this.page = 1
      this.list = []
      this.getListData()
    },
    changeTagHandle(value) {
      console.log(value)
      this.page = 1
      this.list = []
      this.getListData()
    },
    clickhandle(item) {
      sessionStorage.setItem('keep_active',this.parent.$data.active);//缓存tab页码
      statisticalHandle(item)
      window.location.href = item.url
    }
  }
}
</script>